import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL_NEW } from '@utils/api/endpoints.ts';
import { QueryKeys } from '@utils/api/query-keys.ts';
import { SpeakerListResponse } from '@utils/types/organization/speaker.ts';
import { PagedListParams } from '@utils/api/endpoints.paged.ts.tsx';

export const useGetSpeakers = (params?: PagedListParams) => {
  const fetchSpeakers = async (): Promise<SpeakerListResponse> => {
    const url = GET_URL_NEW(params).speakers;
    const { data } = await Axios.get<SpeakerListResponse>(url);
    return data;
  };

  const offset =
    typeof params?.offset === 'string' ? Number(params.offset) : params?.offset;
  const limit =
    typeof params?.limit === 'string' ? Number(params.limit) : params?.limit;
  const q = Array.isArray(params?.q) ? params?.q.join(',') : params?.q;

  return useQuery(
    QueryKeys.speakers(offset, limit, q, params?.sort, params?.direction),
    fetchSpeakers
  );
};
